import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditChainId extends Component {

    state = {
        chainId: this.props.chainId,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { chainId = '' } = this.state

        return (
            <Modal
                narrow
                extraClassName="EditChainId"
                onCancel={this.props.onClose}
                onSave={this.onSave}
                saveText="Save"
                mode="edit"
                title="Chain Id">
                <Form>
                    <div>
                        <input
                            type="url"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            placeholder="Chain Id"
                            value={chainId}
                            onChange={e => this.setState({ chainId: e.target.value })} />
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default EditChainId


// WEBPACK FOOTER //
// ./src/components/LBUs/EditChainId.js